import React from "react";
import { useNavigate } from "react-router-dom";
import { premiumPaths } from "../../navigation";
import { Field } from "../Fields";

/** Wybiera słownik z konfiguracji firmy i zapisuje wybór w adresie strony. */
export default function DictionarySelector({
  organizationId,
  definitions,
  definition,
  admin,
}) {
  const navigate = useNavigate();
  if (definitions.length === 1) return <h2>{definition.label}</h2>;
  return (
    <div className="premium-dictionary-selection">
      <Field
        label="Słownik"
        value={definition.kind}
        onChange={(event) =>
          navigate(
            premiumPaths.dictionary(organizationId, event.target.value, admin),
          )
        }
      >
        {definitions.map((item) => (
          <option key={item.kind} value={item.kind}>
            {item.label}
          </option>
        ))}
      </Field>
    </div>
  );
}
